export const CATEGORY_DIAGNOSTIC_ERROR_CODES = [
  'CATEGORY_ORPHAN_IN_CONFIG',
  'CATEGORY_ORPHAN_IN_QUESTIONS',
  'CATEGORY_COVERAGE_GAP',
]

export const isCategoryDiagnosticCode = (code) =>
  CATEGORY_DIAGNOSTIC_ERROR_CODES.includes(code)

export const filterNonCategoryDiagnostics = (items = []) =>
  (Array.isArray(items) ? items : []).filter(
    (item) => !isCategoryDiagnosticCode(item && item.code)
  )

export const buildEffectiveDiagnosticsStatus = (
  status = {},
  showCategoryDiagnostics = true
) => {
  const errors = Array.isArray(status.errors) ? status.errors : []
  const warnings = Array.isArray(status.warnings) ? status.warnings : []

  if (showCategoryDiagnostics) {
    return { ...status, errors, warnings }
  }

  const filteredErrors = filterNonCategoryDiagnostics(errors)
  const filteredWarnings = filterNonCategoryDiagnostics(warnings)
  const hadCategoryOnlyErrors =
    status.ok === false && filteredErrors.length === 0

  return {
    ...status,
    ok: hadCategoryOnlyErrors ? true : status.ok,
    errors: filteredErrors,
    warnings: filteredWarnings,
  }
}

export const hasBlockingDiagnosticsStatus = (
  status = {},
  showCategoryDiagnostics = true
) => {
  const effectiveStatus = buildEffectiveDiagnosticsStatus(
    status,
    showCategoryDiagnostics
  )
  return effectiveStatus.ok === false
}
